import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
import { UpdateParameterValues } from "../services/City";
function SitePotential(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  React.useEffect(() => {

    if (props.value == "") {
      //setValue(0);
    }
    else {

      if (props.object["Site Potential"].find((item) => item.ParameterId == 217)) {
        var usedFloor = props.object["Site Potential"].find((item) => item.ParameterId == 217).value;
        var maxFloor = props.object["Site Potential"].find((item) => item.ParameterId == 86).value;

        if (parseFloat(usedFloor) > parseFloat(maxFloor)) {
          document.getElementById(props.structureType + "-217").style.border = "2px solid red";
        }
        else {
          document.getElementById(props.structureType + "-217").style.border = "1px solid rgba(0, 0, 0, 0.2)";
        }

      }

      setValue(props.value);
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }

    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);
    if (props.ischecked === true) {
      var pclass = IsStyle;
      SetStyle("form-control construction ischecked");
    }
    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);
  }, []);



  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    setchecked(true);
    setchecked1(true);
    //  props.data.find((item) => item.ParameterId == parameterid && item.structureType==structuretype).ischecked=true;



    if (structuretype == "Single Family") {
      if (parameterid == 37) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-249").style.background = "#f7fafd";
        document.getElementById(structuretype + "-250").style.background = "#f7fafd";

      }
      if (parameterid == 249) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 250 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-37").style.background = "#f7fafd";
        document.getElementById(structuretype + "-250").style.background = "#f7fafd";

      }
      if (parameterid == 250) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 37 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 249 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-37").style.background = "#f7fafd";
        document.getElementById(structuretype + "-249").style.background = "#f7fafd";

      }

      if (parameterid == 251) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-38").style.background = "#f7fafd";
        document.getElementById(structuretype + "-252").style.background = "#f7fafd";

      }
      if (parameterid == 38) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 252 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-251").style.background = "#f7fafd";
        document.getElementById(structuretype + "-252").style.background = "#f7fafd";

      }
      if (parameterid == 252) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 251 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 38 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-251").style.background = "#f7fafd";
        document.getElementById(structuretype + "-38").style.background = "#f7fafd";

      }
      if (parameterid == 253) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-39").style.background = "#f7fafd";
        document.getElementById(structuretype + "-254").style.background = "#f7fafd";

      }
      if (parameterid == 39) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 254 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-253").style.background = "#f7fafd";
        document.getElementById(structuretype + "-254").style.background = "#f7fafd";

      }
      if (parameterid == 254) {
        props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Site Potential"].find((item) => item.ParameterId == 39 && item.structureType == structuretype).ischecked = false;
        props.object["Site Potential"].find((item) => item.ParameterId == 253 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-253").style.background = "#f7fafd";
        document.getElementById(structuretype + "-39").style.background = "#f7fafd";

      }
    }
    if (parameterid == 256) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-36").style.background = "#f7fafd";
      if (structuretype == "Apartment") {
        props.object["Site Potential"].find((item) => item.ParameterId == 69 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-69").style.background = "#f7fafd";
      }
      else {
        props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-258").style.background = "#f7fafd";
      }
    }
    if (parameterid == 36) {
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-256").style.background = "#f7fafd";
      if (structuretype == "Apartment") {
        props.object["Site Potential"].find((item) => item.ParameterId == 69 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-69").style.background = "#f7fafd";
      }
      else {
        props.object["Site Potential"].find((item) => item.ParameterId == 258 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-258").style.background = "#f7fafd";
      }
    }
    if (structureType == "Apartment") {
      if (parameterid == 69) {
        props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
        props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
        props.object["Sales Cost Breakdown"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
        document.getElementById(structuretype + "-36").style.background = "#f7fafd";
        document.getElementById(structuretype + "-256").style.background = "#f7fafd";
      }
    }
    if (parameterid == 258) {
      console.log("Abdul Qadeer")
      props.object["Site Potential"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Site Potential"].find((item) => item.ParameterId == 36 && item.structureType == structuretype).ischecked = false;
      props.object["Site Potential"].find((item) => item.ParameterId == 256 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-36").style.background = "#f7fafd";
      document.getElementById(structuretype + "-256").style.background = "#f7fafd";

    }
    // if(parameterid==64)
    // {
    //   const input = document.getElementById(structuretype+"-265");

    //   const event = new Event("onChange", { bubbles: true });
    //   input.value=6;

    //   //props.data.find((item) => item.ParameterId == 265 && item.structureType==structuretype).setValue;
    //   event.simulated = true;

    //   console.log(props.data.find((item) => item.ParameterId == 265 && item.structureType==structuretype));
    // }
    // if(parameterid==265)
    // {
    //   document.getElementById(structuretype+"-65").value="22222226"
    //   props.data.find((item) => item.ParameterId == 65 && item.structureType==structuretype).value=222222; 
    // }
    props.setData({ ...props.wholeEl, value: e.target.value, ischecked: true })

    if (e.target.value != "" && e.target.value > 0) {
      UpdateParameterValues(structuretype, props);
      // document.getElementById(e.target.id).value="0";

      // setLoading(true)

      // var formID=Cookies.get('FormID');
      // let newArr =[];
      //   newArr=({
      //    ParameterId: parameterid,ParameterName: props.name,ParameterTypeId:props.ParameterTypeId,value: e.target.value,
      //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: 0,perprojectvalue: 0, ParamOrder: 0,
      //  });

      //  var name=Cookies.get('username');
      //  let params = {
      //   username: name,
      //   Stage:"P",
      //   formId: formID,
      //   userType:"AutoSave",
      //   parameters: []
      //  };
      //  params.StructureTypes=[{
      //   StructureType: structuretype,
      //   Calculations: [newArr],}
      //  ]
      //  params = JSON.stringify({
      //    Body: params,
      //  });
      //  console.log(params)
      //  return axios
      //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
      //      headers: {
      //        "Content-Type": "application/json",
      //        Accept: "application/json",
      //      },
      //      crossorigin: true,
      //    })
      //    .then((res) => {
      //    // setLoading(false);
      //    console.log("here")
      //      return res.data;
      //    })
      //    .catch((e) => {
      //    // setLoading(false);
      //      alert(e.message);
      //    });  
    }
  }


  const onChange1 = (e) => {
    setchecked(e.target.checked);
    setchecked1(e.target.checked);
    props.setData({ ...props.wholeEl, ...props.wholeEl.ischecked, ischecked: e.target.checked, value: value })


  };

  function setPreviousValue(ID) {
    let e = ID.split('-')[1];

    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    let color1 = document.getElementById("color1").value;
    let color2 = document.getElementById("color2").value;
    let color3 = document.getElementById("color3").value;
    if (previuosID == 198) {
      document.getElementById(StructureType + "-198").style.background = color1;
      document.getElementById(StructureType + "-229").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-201").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-202").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-200").style.background = color2;
      }
    }

    if (previuosID == 186) {
      document.getElementById(StructureType + "-186").style.background = color1;
      document.getElementById(StructureType + "-224").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-208").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-209").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-223").style.background = color2;
      }
    }
    if (previuosID == 88) {
      document.getElementById(StructureType + "-88").style.background = color1;
      document.getElementById(StructureType + "-238").style.background = color2;
    }
    if (previuosID == 89) {
      document.getElementById(StructureType + "-89").style.background = color1;
      document.getElementById(StructureType + "-237").style.background = color2;
    }
    if (previuosID == 91) {
      document.getElementById(StructureType + "-91").style.background = color1;
      document.getElementById(StructureType + "-236").style.background = color2;
    }
    if (previuosID == 105) {
      document.getElementById(StructureType + "-105").style.background = color1;
      document.getElementById(StructureType + "-235").style.background = color2;
    }
    if (previuosID == 90) {
      document.getElementById(StructureType + "-90").style.background = color1;
      document.getElementById(StructureType + "-234").style.background = color2;
    }
    if (previuosID == 106) {
      document.getElementById(StructureType + "-106").style.background = color1;
      document.getElementById(StructureType + "-233").style.background = color2;
    }
    if (previuosID == 87) {
      document.getElementById(StructureType + "-87").style.background = color1;
      document.getElementById(StructureType + "-232").style.background = color2;
    }
    if (previuosID == 109) {
      document.getElementById(StructureType + "-109").style.background = color1;
      document.getElementById(StructureType + "-97").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 113) {
      document.getElementById(StructureType + "-113").style.background = color1;
      document.getElementById(StructureType + "-102").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 114) {
      document.getElementById(StructureType + "-114").style.background = color1;
      document.getElementById(StructureType + "-103").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 112) {
      document.getElementById(StructureType + "-112").style.background = color1;
      document.getElementById(StructureType + "-100").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 111) {
      document.getElementById(StructureType + "-111").style.background = color1;
      document.getElementById(StructureType + "-101").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 110) {
      document.getElementById(StructureType + "-110").style.background = color1;
      document.getElementById(StructureType + "-99").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 45) {
      document.getElementById(StructureType + "-45").style.background = color1;
      document.getElementById(StructureType + "-246").style.background = color2;
      document.getElementById(StructureType + "-181").style.background = color3;
    }

    if (previuosID == 226) {
      document.getElementById(StructureType + "-226").style.background = color2;
      document.getElementById(StructureType + "-248").style.background = color3;
    }
    if (previuosID == 256) {
      document.getElementById(StructureType + "-256").style.background = color1;
      document.getElementById(StructureType + "-36").style.background = color2;
      document.getElementById(StructureType + "-258").style.background = color3;
    }
    if (previuosID == 41) {
      document.getElementById(StructureType + "-41").style.background = color1;
      document.getElementById(StructureType + "-259").style.background = color2;
      document.getElementById(StructureType + "-255").style.background = color3;
    }

    if (previuosID == 43) {
      document.getElementById(StructureType + "-43").style.background = color2;
      document.getElementById(StructureType + "-260").style.background = color3;
    }
    if (previuosID == 44) {
      document.getElementById(StructureType + "-44").style.background = color2;
      document.getElementById(StructureType + "-261").style.background = color3;
    }
    if (previuosID == 42) {
      document.getElementById(StructureType + "-42").style.background = color2;
      document.getElementById(StructureType + "-262").style.background = color3;
    }
  }

  function showInfo(ID) {

    let e = ID.split('-')[1];
    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    if (previuosID != "" && previuosID != null) {
      setPreviousValue(ID);
    }
    Setinfostyle(ID);
    document.getElementById("PreviousID").value = "";

    document.getElementById(StructureType + "-85").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-86").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-217").style.background = '#f7f7f7';
    if (StructureType !== "Apartment" && StructureType !== "Condo") {
      document.getElementById(StructureType + "-96").style.background = 'transparent';
    }
    if (StructureType == "Apartment" || StructureType == "Condo") {
      document.getElementById(StructureType + "-79").style.background = 'transparent';

      document.getElementById(StructureType + "-71").style.background = '#f7f7f7';
    }

    document.getElementById(ID).style.background = '#fffce6';


    if (e == 85) {

      document.getElementById("HSite Potential" + StructureType).innerText = "Floor Area Ratio ";
      document.getElementById("ISite Potential" + StructureType).innerText = "F.A.R.is a ratio given by a local government that dictates the maximum usable floor area for a building structure. The higher the ratio, the more dense a structure can be. Max Floor Area/ Total Lot Size";
      SetIsHeader("Floor Area Ratio ");
      SetIsinfo("F.A.R.is a ratio given by a local government that dictates the maximum usable floor area for a building structure. The higher the ratio, the more dense a structure can be. Max Floor Area/ Total Lot Size");
      SetIsDisplay("info");
    }
    if (e == 86) {
      document.getElementById("HSite Potential" + StructureType).innerText = "Max Floor Area";
      document.getElementById("ISite Potential" + StructureType).innerText = "Max floor area is the maximum allowable size for a given structure type set by the local government. Floor Area Ratio * Total Lot Size";

      SetIsHeader("Max Floor Area");
      SetIsinfo("Max floor area is the maximum allowable size for a given structure type set by the local government. Floor Area Ratio * Total Lot Size");
      SetIsDisplay("info");
    }
    if (e == 217) {
      document.getElementById("HSite Potential" + StructureType).innerText = "Used Floor Area ";
      document.getElementById("ISite Potential" + StructureType).innerText = "The proposed building’s floor area set by the user. Total Project SF. / Sellable SF. Factor (Single Family, Townhome, Rowhouse, Cottage) Total Project SF. / 1 - Inefficient Space Percentage (Condo & Apartment)";

      SetIsHeader("Used Floor Area ");
      SetIsinfo("The proposed building’s floor area set by the user. Total Project SF. / Sellable SF. Factor (Single Family, Townhome, Rowhouse, Cottage) Total Project SF. / 1 - Inefficient Space Percentage (Condo & Apartment)");
      SetIsDisplay("info");
    }
    if (e == 96) {
      document.getElementById("HSite Potential" + StructureType).innerText = "Sellable Sqft Factor";
      document.getElementById("ISite Potential" + StructureType).innerText = "An estimated ratio to calculate the wall square footage since Floor Area does not include wall space and average home square footage includes wall space. Total Project SF. /Used Floor Area";

      SetIsHeader("Sellable Sqft Factor ");
      SetIsinfo("An estimated ratio to calculate the wall square footage since Floor Area does not include wall space and average home square footage includes wall space. Total Project SF. /Used Floor Area");
      SetIsDisplay("info");
    }
    if (e == 79) {
      document.getElementById("HSite Potential" + StructureType).innerText = "Inefficient Space Percentage";
      document.getElementById("ISite Potential" + StructureType).innerText = "The excess space that is counted towards Floor Area which includes hallways, utility rooms, indoor amenity spaces, and any other indoor space that is outside the Livable Sqft.  1- (Livable Sqft / Used Floor Area)";

      SetIsHeader("Inefficient Space Percentage");
      SetIsinfo("The excess space that is counted towards Floor Area which includes hallways, utility rooms, indoor amenity spaces, and any other indoor space that is outside the Livable Sqft.  1- (Livable Sqft / Used Floor Area)");
      SetIsDisplay("info");
    }
    if (e == 71) {
      document.getElementById("HSite Potential" + StructureType).innerText = "Livable Sqft";
      document.getElementById("ISite Potential" + StructureType).innerText = "The area of the dwelling space within a building. Used Floor Area – Inefficient Space";

      SetIsHeader("Livable Sqft");
      SetIsinfo("The area of the dwelling space within a building. Used Floor Area – Inefficient Space");
      SetIsDisplay("info");
    }

    document.getElementById("Land Analysis" + StructureType).style.display = 'none';
    document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Site Potential" + StructureType).style.display = 'block';
  }
  if (props.id == 284 || props.id == 285 || props.id == 286) {
    return (
      <>
        <div class="col-md-3 col-6 mt-2" style={{}}>

          <label class="" >{props.name}
          </label>

        </div>
        <div class="col-md-9 col-6 mt-2" style={{}}>

          <input
            type="text"
            key={props.structureType + "-" + props.id}
            id={props.structureType + "-" + props.id}
            value={value}
            readOnly
            class="form-control"
            style={{ maxWidth: "100%" }}
          />

        </div>
      </>
    );
  }
  if (props.id == 256 || props.id == 36 || props.id == 258 || props.id == 69) {
    if (props.id == 258) {

      return (

        <>


          <div class="col-md-4 col-6" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
          <div class="row" style={{ width: "96%", marginTop: "2%" }}>

            <p style={{ width: "94%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>   <div class="row" style={{ width: "96%", marginTop: "2%" }}>

              <p style={{ width: "94%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>“User to verify site potential
                information, software only references to city code, software does not reference to
                anything outside of city code to perform projections such as easements, covenants,
                restrictions and etc.
              </p></div>
            </p></div>


        </>

      );

    }
    else {
      if (props.id == 256) {
        if (props.structureType == "Single Family") {
          return (

            <>

              <div class="col-md-6" >
                <div class="from  d-flex justify-content-between  align-items-center ">
                  <label class=""><u>Total Estimated Value</u>
                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>

                  </label>



                </div>
              </div>


            </>
          );
        }
        else {

          return (

            <>


              <div class="col-md-12 input-box1 mt-3">
                <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-2"><label class="d-block text-center">Per sqft</label></div>
                  <div class="col-md-3"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3 " >
                <label class="">{props.name.split('Per')[0]}
                  <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                    <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                  </svg></span>

                </label>



              </div>

              <div class="col-md-3">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>

            </>
          );
        }


      } else {

        return (

          <>


            <div class="col-md-3" >
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </>
        );
      }
    }
  }
  if (props.id == 37 || props.id == 249 || props.id == 250) {
    if (props.id == 249) {


      return (

        <>
          <div class="ml-2 table-outer mt-4">
            <div class="row mytable ">

              <div class="col-md-12 input-box1 ">
                <div class="row" >
                  <div class="col-md-3 col"></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Per sqft </label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
                  <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
                </div></div>
              <div class="col-md-3 col" >
                <label class="">{props.name.split('Per')[0]}

                </label>


              </div>

              <div class="col-md-3 col-6">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div> </div>
          </div>
        </>
      );

    } else {

      return (

        <>


          <div class="col-md-3 col-6" >
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );
    }
  }

  if (props.id == 30 || props.id == 96 || props.id == 215 || props.id == 199 || props.id == 80 || props.id == 71 || props.id == 216 || props.id == 79 || props.id == 188 || props.id == 32 || props.id == 33 || props.id == 35 || props.id == 67 || props.id == 34) {
    if (props.id == 30 || props.id == 199 || props.id == 215 || props.id == 80 || props.id == 216 || props.id == 188 || props.id == 32 || props.id == 33 || props.id == 34 || props.id == 35 || props.id == 67) {
      if (props.id == 216) {



        return (
          <>
            <div class="col-md-3 col-6" style={{}}>
              <label class="">{props.name}
              </label>


            </div>
            <div class="col-md-3 col-6 mt-2" style={{}}>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"
                style={{ maxWidth: "100%" }}
              />

            </div>
            <div class="col-md-6"></div>
          </>
        );
      }
      if (props.id == 199) {



        return (
          <>
            <div class="col-md-3 col-6" style={{}}>
              <label class="">{props.name}
              </label>

            </div>
            <div class="col-md-3 col-6 mt-2" style={{}}>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"
                style={{ maxWidth: "100%" }}
              />
            </div>
          </>
        );
      }
      else {
        if (props.ischecked == true) {

          return (
            <>
              <div class="col-md-3 col-6 mt-2" style={{}}>
                <label class="">{props.name}
                </label>
              </div>

              <div class="col-md-3 col-6 mt-2" style={{}}>

                <input
                  style={{ backgroundColor: "#e7f0fa", maxWidth: "100%" }}
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name}

                  class="form-control"

                />
              </div> </>
          );
        }
        else {
          return (
            <>
              <div class="col-md-3 col-6 mt-2" style={{}}>
                <label class="">{props.name}
                </label>
              </div>
              <div class="col-md-3 col-6 mt-2" style={{}}>
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name}
                  class="form-control"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </>
          );
        }
      }
    }
    else if (props.id == 71) {

      return (
        <>
          <div class="col-md-3 col-6" style={{}}>
            <label class="">{props.name}
              <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
              </svg></span>

            </label>
          </div>
          <div class="col-md-3 col-6" style={{}}>

            <input

              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              //placeholder={props.name}
              readOnly
              class="form-control"
              style={{ maxWidth: "100%" }}
            />

          </div>
        </>
      );
    }
    else if (props.id == 79) {

      return (
        <>
          <div class="col-md-3 col-6" style={{}}>

            <label class="">{props.name}
              <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
              </svg></span>
            </label>

          </div>
          <div class="col-md-3 col-6" style={{}}>

            <div class="test1" >
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                class="form-control  construction"
                style={{ maxWidth: "100%" }}
              />
            </div>
          </div>
        </>

      );

    }

    else {
      if (props.ischecked == true) {

        return (
          <>
            <div class="col-md-3 col-6 mt-2" style={{}}>
              <label class="">{props.name}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>
              </label>

            </div>
            <div class="col-md-3 col-6 mt-2" style={{}}>


              <input
                style={{ backgroundColor: "#e7f0fa", maxWidth: "100%" }}
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}

                class="form-control"

              />
            </div>
          </>
        );
      }
      else {
        return (
          <>
            <div class="col-md-3 col-6 mt-2" style={{}}>
              <label class="">{props.name}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>
              </label>

            </div>
            <div class="col-md-3 col-6 mt-2" style={{}}>


              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                style={{ maxWidth: "100%" }}
                class="form-control"

              />
            </div>
          </>
        );
      }
    }

  }
  else {
    if (props.id == 185) {


      return (
        <>
          <div class="col-md-2 col-12">
            <label class="d-block">{props.name}
            </label>

            <input

              type="text"
              key={props.structureType + "-" + props.id}
              id={props.structureType + "-" + props.id}
              value={value}
              onChange={onChange}
              //placeholder={props.name}
              readOnly
              class="form-control"
              style={{ width: "50%" }}
            />

          </div>
          <div class="row ml-2" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.2)", width: "90%", marginBottom: "2%", marginTop: "2%" }}></div>
        </>
      );
    }

    else {
      if (props.id == 184) {

        if (props.ischecked == true) {

          return (
            <div class="col-md-2 col-12">
              <label class="d-block">{props.name}
              </label>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />

            </div>
          );
        }
        else {
          return (
            <div class="col-md-2 col-12">
              <label class="d-block">{props.name}
              </label>

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />
            </div>
          );
        }
      }
      else {
        if (props.isManual == true) {

          return (
            <div class="col-md-2 col-12">
              <label class="d-block">{props.name}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)}> <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>
              </label>

              <input

                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />

            </div>
          );
        }
        else {
          return (
            <div class="col-md-2 col-12">
              <label class="d-block">{props.name}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)}> <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>
              </label>

              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name}
                readOnly
                class="form-control"

              />
            </div>
          );
        }
      }
    }
  }

}
export default SitePotential;
